import { render } from "./pie_chart_1.svg?vue&type=template&id=1f0ad74e"
const script = {}
script.render = render

export default script